import {IoLocation} from 'react-icons/io5';
import {BsClockHistory} from 'react-icons/bs';
import {RiTeamFill} from 'react-icons/ri';
import {BiSupport} from 'react-icons/bi';
import {BsShield} from 'react-icons/bs';
import '../pages/home/home.css';
import { Link } from 'react-router-dom';

const WhyUs = () => {

    return (
        <div className='whyus'>
            <div className='whyus__container'>
                <div className='whyus_l'>
                    <h3>WHY CHOOSE US</h3>
                    <h1>The pest control expert you can trust.</h1>
                    <p>
                        Our team of expert pest control technicians has years of
                        experience in the industry, and they have the knowledge and expertise to eliminate even the toughest
                        pest problems.
                    </p>
                    <Link to='/about'><button className='btn sm whyus_btn'>Discover More</button></Link>
                </div>
                <div className="whyus_r">
                    <div className='why_r_det'>
                        <BsClockHistory className='why_r_icon' />
                        <h2 style={{color:'black'}}>Timely</h2>
                        <p style={{color:'white'}}>
                            Time is of the essence when it comes to pest control. That's why we pride ourselves on our prompt and efficient service. 
                        </p>
                    </div>
                    <div className='why_r_det'>
                        <RiTeamFill className='why_r_icon' />
                        <h2 style={{color:'black'}}>Expert Team</h2>
                        <p style={{color:'white'}}>
                            Our team consists of highly skilled and experienced pest control specialists.
                        </p>
                    </div>
                    <div className='why_r_det'>
                        <BiSupport className='why_r_icon' />
                        <h2 style={{color:'black'}}>24/7 Support</h2>
                        <p style={{color:'white'}}>
                            Our pest control company offers 24/7 support for exceptional customer service.
                        </p>
                    </div>
                    <div className='why_r_det'>
                        <BsShield className='why_r_icon' />
                        <h2 style={{color:'black'}}>Guaranteed Protection</h2>
                        <p style={{color:'white'}}>Our advanced pest control methods are designed to eliminate pests of all kinds.</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default WhyUs